import ActionsMenu, { ActionMenuItem } from "components/ActionsMenu";

interface CrawlerActionsDropdownProps {
  crawlerId: string;
  status: string;
  enabled?: boolean;
  onEdit: (id: string) => void;
  onDisableScheduling?: (id: string) => void;
}

const CrawlerActionsDropdown = ({
  crawlerId,
  enabled = true,
  onEdit,
  onDisableScheduling,
}: CrawlerActionsDropdownProps) => {
  const items: ActionMenuItem[] = [
    { label: "Edit", onClick: () => onEdit(crawlerId) },
  ];

  if (onDisableScheduling) {
    items.push({
      label: "Disable Scheduling",
      onClick: () => onDisableScheduling(crawlerId),
      disabled: !enabled,
      destructive: true,
    });
  }

  // Returns bare content (not a <td>) — DataTable's TableCell owns the cell.
  // ActionsMenu stops click propagation internally, so no wrapper is needed.
  return <ActionsMenu items={items} ariaLabel="Crawler actions" />;
};

export default CrawlerActionsDropdown;
